<template>
  <div class="clearfix">
    <div class="container my-5">
      <div class="row">
        <div class="col-md-4">
          <br />
          <br />
          <h2 class="text-dark">Consulta de certificados:</h2>
          <br />
          <br />
          <transition name="fade" mode="out-in">
            <template v-if="mensajero.on">
              <b-alert  :variant="mensajero.tipo" show>
                <p>{{ mensajero.texto }}</p>
                <br>
                <b-button variant="secondary" @click="reset" >Hacer otra consulta</b-button>
              </b-alert>
            </template>
            <template v-else>
              <b-form>
                <div class="row">
                  <b-form-group
                    label="Dictamen No:"
                    label-for="numero_dictamen"
                    class="col-md"
                  >
                    <b-form-input
                      v-model="form.numero_dictamen"
                      :state="numerodictamenOk"
                      class="form-control"
                      id="numero_dictamen"
                      placeholder="Ingrese le No. de Dictamen"
                    ></b-form-input>
                    <span class="text-danger" v-if="errors.numero_dictamen">{{
                      errors.numero_dictamen[0]
                    }}</span>
                  </b-form-group>
                </div>
                <br />
                <div class="row">
                  <b-form-group
                    label="Nit o Cédula:"
                    label-for="numero_identificacion"
                    class="col-md"
                  >
                    <b-form-input
                      type="password"
                      v-model="form.numero_identificacion"
                      :state="numeroidentificacionOk"
                      class="form-control"
                      id="numero_identificacion"
                      placeholder="Ingrese Cédula o NIT sin dígito de verificación ni puntos."
                    ></b-form-input>
                    <span class="text-danger" v-if="errors.numero_identificacion">{{
                      errors.numero_identificacion[0]
                    }}</span>
                  </b-form-group>
                </div>
                <br />

                <vue-recaptcha
                sitekey="6LebINQaAAAAAFBTKKdSxdwzYNGMjgT8HTcjoYcG"
                @verify="onVerify"
                @expired="onExpired"
                @error="onError"
                >
                </vue-recaptcha>
                <br>
                <b-button  @click="sendForm" title="Aceptar" variant="secondary">
                  <span class="mr-1">Aceptar</span>
                  <font-awesome-icon icon="arrow-right" class="ms-2"/>
                </b-button>
              </b-form>
            </template>
          </transition>
        </div>
        <div class="col-md-8">
          <transition name="fade" mode="out-in">

              <iframe id="i-pdf" width="100%" height="10px" style="overflow: auto;">
              </iframe>

          </transition>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Connection from '@/api/Connection.js'
import Csrf from '@/api/Csrf'
import VueRecaptcha from 'vue-recaptcha'

export default {
  name: 'Documentos',
  components: {
    VueRecaptcha
  },
  mounted () {
    this.$store.commit('setActualPage', 'Certificados en linea')
    this.reset()
  },
  data () {
    return {
      form: {
        numero_dictamen: null,
        numero_identificacion: null
      },
      disableButton: true,
      mensajero: { on: false, tipo: null, texto: null },
      errors: [],
      archivaldo: null
    }
  },

  methods: {
    async sendForm () {
      await Csrf.getCookie()
      try {
        const response = await Connection.post('api/ceritificado/', this.form)
        if (response.data.message) {
          this.mensajero = { on: true, tipo: 'warning', texto: response.data.message }
        } else {
          this.mensajero = { on: true, tipo: 'warning', texto: 'Su consulta tuvo exito. Guarde en un lugar seguro el archivo.' }
          const type = { type: response.data.tipo }

          // base64 to blob
          const byteCharacters = atob(response.data.data_base64)
          const byteNumbers = new Array(byteCharacters.length)
          for (let i = 0; i < byteCharacters.length; i++) { byteNumbers[i] = byteCharacters.charCodeAt(i) }
          const byteArray = new Uint8Array(byteNumbers)
          const blob = new Blob([byteArray], type)
          const url = window.URL.createObjectURL(blob)
          // document.querySelector('#i-pdf').url = "'data:application/pdf;base64,'" + url
          // document.querySelector('#i-pdf').height = '400px'

          const link = document.createElement('a')
          link.href = url
          link.target = '_blank'
          link.download = response.data.nombre

          // Simulate a click on the element <a>
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }
      } catch (error) {
        this.mensajero = { on: true, tipo: 'danger', texto: 'El sistema ha tenido un problema interno. Intente cerrar el navegador y vuelva ahacer la consulta.' }
        if (error.response.status === 422) {
          this.errors = error.response.data.errors
        }
      }
    },
    async logout () {
      try {
        const response = await Connection.post('/logout', { id: localStorage.getItem('auth') })
        sessionStorage.setItem('Salida', response.data.message)
        this.mensajero = false
      } catch (error) {
        console.log(error)
      }
    },
    reset () {
      this.disableButton = true
      this.mensajero = { on: false, tipo: null, texto: null }
      this.form = { numero_dictamen: null, numero_identificacion: null }
      document.querySelector('#i-pdf').height = '0px'
    },
    onVerify: function (response) {
      // this.disableButton = false
      console.log('Verify: ' + response)
    },
    onExpired: function () {
      // this.disableButton = true
      console.log('Expired')
    },
    onError: function (error) {
      // this.disableButton = true
      console.log(error)
    },

    makeToast (variant = null) {
      this.$bvToast.toast('Donde esta mi archivo?', {
        title: `Variant ${variant || 'default'}`,
        variant: variant,
        solid: true
      })
    }
  },

  computed: {
    tiposolicitanteOk () {
      return this.errors.tipo_solicitante ? true : null
    },
    numerodictamenOk () {
      return this.errors.numero_dictamen ? true : null
    },
    numeroidentificacionOk () {
      return this.errors.numero_identificacion ? true : null
    }
  }
}
</script>

<style>
</style>
